import type { enTainan } from './en.tainan';

export const zhTWTainan: typeof enTainan = {
  tainan: {
    mapNames: { tainan: '台南' },
    zones: {
      tn_city: '台南府城',
      tn_station: '高鐵台南站',
      tn_chihkan: '赤崁樓',
      tn_shennong: '神農街',
      tn_anping: '安平',
      tn_market: '國華街市場',
      tn_confucius: '孔廟',
      tn_canal: '安平運河',
    },
    objects: {
      tn_hsr: '高鐵台南站',
      tn_shuttle: '高鐵快捷公車站（H31）',
      tn_chihkan: '赤崁樓',
      tn_turtles: '贔屭石碑',
      tn_lanterns: '燈籠工作坊',
      tn_zeelandia: '安平古堡',
      tn_treehouse: '安平樹屋',
      tn_shrimp: '蝦餅攤',
      tn_candied: '蜜餞店',
      tn_boatRide: '運河遊船',
      tn_beefSoup: '牛肉湯攤',
      tn_danzai: '擔仔麵攤',
      tn_coffin: '棺材板攤',
      tn_confucius: '孔廟大成殿',
    },
    npc: {
      tn_soupGranny: '牛肉湯阿嬤',
      tn_fortGuide: '古堡導覽員',
      tn_scholar: '孔廟學生',
      tn_crackerLady: '蝦餅老闆娘',
      tn_candiedAunt: '蜜餞阿姨',
      tn_fisher: '運河漁夫',
      tn_kid1: '放風箏的男孩',
      tn_kid2: '畫畫的女孩',
      tn_lanternArtist: '燈籠藝師',
      tn_shuttleDriver: '快捷公車司機',
      tn_cyclist: '單車客',
      tn_grandpa: '下棋的阿公',
      tn_boatman: '船長',
    },
    items: {},

    shuttle: {
      text: '高鐵台南站位在歸仁，離府城約 10 公里。免費的 H31 快捷公車每 20 分鐘一班開往市區，車程約半小時。',
      ask: '🚌 問司機（英語）',
      q: '要怎麼問這班車是否開往市中心？',
      // English practice
      a: ['Excuse me, does this bus go to the city centre?', 'Bus! City! Now!', 'You drive me downtown.'],
      right: '「Yes! Chihkan Tower is the fourth stop. Hold on tight!」',
      wrong: '司機皺了皺眉。再試試更有禮貌的問法，先說「Excuse me…」。',
    },
    chihkan: {
      text: '赤崁樓建在荷蘭人 1653 年所築的普羅民遮城上。清代後來加蓋了這兩座樓閣：海神廟，以及供學子祈福的文昌閣。',
      learn: '🏯 誰蓋了這座城？（英語）',
      q: 'Who built the first fort here?',
      // English practice
      a: ['The Dutch, in 1653.', 'The Romans, in 100.', 'The Japanese, in 1950.'],
      right: '答對了！荷蘭人統治台南 38 年，直到 1662 年鄭成功把他們趕走。',
      wrong: '看看紅磚台基，它已經 370 歲了……',
    },
    turtles: {
      text: '九隻石龜（贔屭）背著高高的石碑，是乾隆皇帝 1788 年賜下的。傳說其中一隻掉進港裡，只好另外補刻一隻！',
      count: '🐢 數數石龜（英語）',
      q: 'How many turtles were there at first?',
      // English practice: number words
      a: ['Nine.', 'Seven.', 'Twelve.'],
      right: '九隻！背著石碑的龜象徵長壽與喜訊。',
      wrong: '再數一次，用手指，用英語……',
    },
    confucius: {
      text: '台南孔廟創建於 1665 年，是全台第一座孔廟。門上掛著「全臺首學」匾額。考試前，學生們至今仍會來這裡祈福。',
      learn: '📜 讀匾額（英語）',
      q: 'What does 全臺首學 mean?',
      // English practice
      a: ['The first school of all Taiwan.', 'The biggest market of Taiwan.', 'No running in the temple.'],
      right: '對！「首」是 first，「學」是 school。你像學生一樣向老師行了一禮。',
      wrong: '提示：這裡是學校，不是市場……',
    },
    zeelandia: {
      text: '安平古堡（熱蘭遮城）建於 1624 年，是荷蘭人在台灣的總部。1662 年鄭成功圍城九個月，荷蘭人終於乘船離去。原始的紅磚牆只剩幾段，白色瞭望塔是 1930 年蓋的。',
      learn: '🏰 哪個國家？（英語）',
      q: 'Which country built Fort Zeelandia?',
      // English practice
      a: ['The Netherlands.', 'Spain.', 'Australia.'],
      right: '正確，是荷蘭！他們的磚頭是從爪哇當船隻的壓艙物一路運來的。',
      wrong: '塔上的旗子有紅、白、藍三條……',
    },
    treehouse: {
      text: '安平樹屋原本是英商德記洋行的倉庫。廢棄之後，一棵榕樹爬過牆壁、鑽過窗戶、覆蓋屋頂——現在樹就是屋。',
      learn: '🌳 描述一下（英語）',
      q: 'What happened to the warehouse?',
      // English practice: past tense
      a: ['A tree grew over it.', 'A tree will grow over it.', 'A tree is eating my lunch.'],
      right: '「Grew」是 grow 的過去式。氣根像一簾簾繩子！',
      wrong: '那是很久以前發生的事。哪個答案是過去式？',
    },
    lanterns: {
      text: '神農街的燈籠藝師手繪紙燈籠：紅色求好運、黃色求財富，還有一個畫了龍，要在元宵節掛出來。',
      paint: '🏮 選個顏色（英語）',
      q: 'The artist holds up a lantern the colour of a ripe tomato. What colour is it?',
      // English practice: colours
      a: ['Red.', 'Blue.', 'Green.'],
      right: 'Red！她在上面寫了「福」，掛在巷子上方送給你。',
      wrong: '看看桌上的番茄當提示……',
      closed: '鐵門拉下來了；燈籠藝師下午三點以後才開工。',
    },
    boat: {
      text: '遊船在安平運河上滑行，穿過橋下，駛向舊港。船長講著一百年前鹽船行駛在這條水道上的故事。',
      ride: '🚤 買船票（英語）',
      price: 50,
      poor: '船票要 50 枚硬幣。帶多一點零用錢再來吧！',
      q: 'How do you ask for a ticket?',
      // English practice
      a: ['One ticket for the boat tour, please.', 'Boat. Me. Go.', 'Give ticket boat now.'],
      right: '水上三十分鐘：岸邊有白鷺鷺，遠處是古堡塔，涼風吹來。真美！',
      wrong: '船長耐心地笑了。試試加上「…please」。',
      closed: '今天最後一班船已經開走了。遊船時間是九點到六點。',
    },
    beefSoup: {
      vendor: 'Fresh beef soup! The beef is sliced thin and cooked in the hot broth right in your bowl. One bowl?',
      ok: 'One bowl of beef soup with rice, please.',
      bad: ['Beef. Bowl. Hurry.', 'I want beef soup, but no beef and no soup.'],
      done: '牛肉粉嫩軟嫩，湯頭帶著薑的甘甜。阿嬤多送你一匙白飯：「慢慢吃！」',
      price: 45,
    },
    danzai: {
      vendor: 'Danzai noodles — the Tainan way since 1895! A small bowl with a shrimp on top. Would you like one?',
      ok: 'Yes, please. One bowl of danzai noodles.',
      bad: ['Noodle give.', 'I eat all noodles, you pay.'],
      done: '小小一碗：麵、肉燥、一尾蝦，再滴一點黑醋。小，但剛剛好。',
      price: 40,
    },
    coffin: {
      vendor: 'Coffin bread! Don’t worry — it’s just a box of fried toast filled with creamy chicken stew. Hungry?',
      ok: 'Could I have one coffin bread, please?',
      bad: ['Coffin! Scary!', 'Toast box me want.'],
      done: '外酥內滑。名字來自它的形狀——一個有蓋子的吐司盒。好吃！',
      price: 35,
    },
    shrimp: {
      vendor: 'Anping shrimp crackers, fried this morning! Light as air. Original or spicy?',
      ok: 'One bag of the original crackers, please.',
      bad: ['Crackers. All. Mine.', 'Spicy no original yes give.'],
      done: '一大袋粉紅色的蝦餅，酥脆又鹹甜。老闆娘多塞了一片「路上吃」。',
      price: 30,
    },
    candied: {
      vendor: 'Candied fruit from Anping: plums, mango, olives, tomatoes with ginger… Try a sample?',
      ok: 'Could I try the candied mango, please?',
      bad: ['Candy sample free all.', 'Me eat jar.'],
      done: '酸酸甜甜還帶點鹹。阿姨包了一小袋芒果乾和幾顆梅子，讓你在車上吃。',
      price: 35,
    },
    closedMorning: '鍋子空了！牛肉湯是早餐，下午兩點前來吧。',

    talk: {
      tn_soupGranny: [
        '我在這裡賣牛肉湯四十年了。牛肉來自善化，每天天亮現宰。',
        'English practice: “Would you like rice with that?” — “Yes, please!”',
        '台南人吃甜。連我們的湯都有點甜！',
      ],
      tn_fortGuide: [
        '這些紅磚是荷蘭船從爪哇運來當壓艙物的。四百年了！',
        'English practice: “Where are you from?” — “I’m from Taiwan.”',
        '從塔上看得到海——1624 年的時候，海水就打到這道牆邊。',
      ],
      tn_scholar: [
        '學生會把准考證放在供桌上求好運。我上星期也放了。',
        'English practice: “Good luck on your exam!” — “Thank you!”',
        '孔子說：學而不思則罔，思而不學則殆。',
      ],
      tn_crackerLady: [
        '蝦餅是用真的蝦子和樹薯粉做的。看它們在油裡膨起來！',
        'English practice: “How much is one bag?” — “Thirty dollars.”',
      ],
      tn_candiedAunt: [
        '水果先曬太陽，再用糖和鹽醃。一顆好梅子要三個星期！',
        'English practice: “Can I try one?” — “Of course, here you are.”',
      ],
      tn_fisher: [
        '運河是 1926 年挖的，當年運魚、運鹽進城。現在運觀光客！',
        'English practice: “Did you catch anything?” — “Not yet… the fish are sleeping.”',
        '看那些白鷺鷺。它們知道魚在哪裡。',
      ],
      tn_kid1: [
        '我的風箏是一隻燕子！運河邊的風是全台南最好的。',
        'English practice: “Look! It’s flying!” — “Wow!”',
      ],
      tn_kid2: [
        '我在畫石龜。九隻：一、二、三……第四隻鼻子缺了一角。',
        'English practice: “What are you drawing?” — “I’m drawing a turtle.”',
      ],
      tn_lanternArtist: [
        '這條街上每一個燈籠都是手繪的。畫龍的那個花了我三天。',
        'English practice: “What colour do you like?” — “I like red.”',
        '晚上的神農街是金色的。留下來等燈籠亮起來吧！',
      ],
      tn_shuttleDriver: [
        'H31 往市區，持高鐵票免費。下一班十分鐘後發車。',
        'English practice: “Does this bus stop at Chihkan Tower?” — “Yes, the fourth stop.”',
      ],
      tn_cyclist: [
        '台南很平，最適合騎單車。運河步道一路通到海邊。',
        'English practice: “Turn left at the bridge.”',
      ],
      tn_grandpa: [
        '象棋。將帥不能離開九宮——就像我，從來不離開台南！',
        'English practice: “Your move.” — “Hmm… let me think.”',
        '我小時候，運河上還有載鹽的帆船。',
      ],
      tn_boatman: [
        '遊船會經過五座橋。第三座橋記得低頭！',
        'English practice: “Please sit down and hold the rail.”',
      ],
    },
  },
};
